<template>
  <div class="kp-modular-label kp-label-step">
    {{ $t('edit.canvas.you_are_editing') }} <span class="kp-label-id">{{ $t('general.labels.step') }} {{step.position + 1}}</span>
  </div>
</template>

<script>
export default {
  props: [
    'step',
  ],
};
</script>



/** WEBPACK FOOTER **
 ** TopMessage.vue?0aead8ba
 **/